import useHasInvertedColors from '@hooks/useHasInvertedColors'
import useIsInHerotellingPage from '@hooks/useIsInHerotellingPage'
import useIsEndOfArticle from './useIsEndOfArticle'

const useIsDarkModeInSocialButton = () => {
  const isEndOfArticle = useIsEndOfArticle()
  const isHerotellingArticle = useIsInHerotellingPage()
  const hasInvertedColors = useHasInvertedColors()

  return hasInvertedColors || (isHerotellingArticle && !isEndOfArticle)
}

export default useIsDarkModeInSocialButton
